module.exports = __webpack_public_path__ + "assets/img/ldxc.6409eca1.png";